import { z } from 'zod';
const blockTypeSchema = z.enum([
    'text',
    'action_preview',
    'data_result',
    'record_embed',
    'bulk_edit',
    'reasoning_trace',
    'approval_required',
    'citation_pill',
    'suggested_next_steps',
    'chart',
    'tool_error'
]);
export const chartSpecSchema = z.object({
    kind: z.enum(['line', 'bar', 'area', 'pie', 'scatter']),
    title: z.string().max(120).optional(),
    x: z.object({
        key: z.string(),
        label: z.string().optional(),
        type: z.enum(['category', 'time', 'number']).default('category'),
    }),
    series: z.array(z.object({
        key: z.string(),
        label: z.string().optional(),
        format: z.enum(['number', 'currency', 'percent']).default('number'),
    })).min(1).max(6),
    stacked: z.boolean().default(false),
    data: z.array(z.record(z.union([z.string(), z.number(), z.null()]))).max(200),
});
export const streamEventSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('turn_start'), turnId: z.string() }),
    z.object({ type: z.literal('text_delta'), delta: z.string() }),
    z.object({ type: z.literal('block_start'), blockId: z.string(), blockType: blockTypeSchema }),
    z.object({ type: z.literal('block_delta'), blockId: z.string(), delta: z.unknown() }),
    z.object({ type: z.literal('block_end'), blockId: z.string() }),
    z.object({ type: z.literal('tool_call_start'), toolId: z.string(), label: z.string() }),
    z.object({
        type: z.literal('tool_call_end'),
        toolId: z.string(),
        blockId: z.string(),
        status: z.enum(['done', 'error', 'awaiting_approval']).optional(),
        query: z.string().optional(),
        rows: z.number().optional(),
        ms: z.number().optional(),
        label: z.string().optional(),
    }),
    z.object({
        type: z.literal('error'),
        code: z.string(),
        message: z.string(),
        retryable: z.boolean(),
    }),
    z.object({
        type: z.literal('done'),
        turnId: z.string(),
        inputTokens: z.number(),
        outputTokens: z.number(),
        credentialMode: z.enum(['platform_managed', 'byok']),
    }),
    z.object({
        type: z.literal('block_status'),
        blockId: z.string(),
        status: z.string(),
        result: z.unknown().optional(),
    }),
]);
//# sourceMappingURL=events.js.map